// modalController.js
import React, { createRef } from "react";
import { DefaultTextModal } from "common/components/Modal/DefaultTextModal";

export const modalRef = createRef();
let modalList = [];

export const openGlobalModal = (props) => {
  const modalId = modalRef.current?.openModal(props);
  console.log(`Modal Opened - ${modalId}`);
  modalList.push(modalId);
  return modalId;
};

export const closeGlobalModal = () => {
  const targetModal = modalList.pop();
  console.log(modalList);
  modalRef.current?.closeModal(targetModal);
};

/**
 * confirm 메시지 팝업
 * @param {string | ReactNode} message - 표시할 메시지 또는 컴포넌트
 * @param {function=} onConfirm - 확인 버튼 눌렀을 때 실행할 함수
 * @param {function=} onCancel - 취소 버튼 눌렀을 때 실행할 함수
 * @param {object} options - 추가 옵션 (blockOuter 등)
 */
export const showConfirmMessageModal = (
  message,
  onConfirm,
  onCancel,
  options = {},
) => {
  const handleConfirm = () => {
    closeGlobalModal();
    onConfirm?.();
  };

  const handleCancel = () => {
    closeGlobalModal();
    onCancel?.();
  };

  openGlobalModal({
    blockOuter: options.blockOuter ?? true,
    onOuterClick: handleCancel,
    content: (
      <DefaultTextModal.Confirm
        message={message}
        onConfirm={handleConfirm}
        onCancel={handleCancel}
      />
    ),
  });
};

/**
 * 메시지 팝업
 * @param {string} message - 표시할 메시지
 * @param {function} onOk - 확인 버튼 콜백
 * @param {object} options - 추가 옵션 (blockOuter 등)
 */
export const showMessageModal = (message, onOk, options = {}) => {
  const handleOk = () => {
    closeGlobalModal();
    onOk?.();
  };

  openGlobalModal({
    blockOuter: options.blockOuter ?? false,
    onOuterClick: handleOk,
    content: <DefaultTextModal.Message message={message} onOk={handleOk} />,
  });
};
